/*
 * Copyright 2022. NXGN Management, LLC. All Rights Reserved.
 */

import { Component } from "@angular/core";
import { faEdit } from "@fortawesome/free-regular-svg-icons";

import { BsModalRef } from "ngx-bootstrap/modal";
import { EditType } from "../../models";

@Component({
  template: ""
})
export class ActionModalComponent {
  title?: string;
  actionInProgress = false;
  faEditPencil = faEdit;
  action!: EditType;
  constructor(private bsModalRef: BsModalRef) {}

  close() {
    this.bsModalRef.hide();
  }

  isAddOrEdit(): boolean {
    return this.action === EditType.edit || this.action === EditType.add;
  }

  isAdd(): boolean {
    return this.action === EditType.add;
  }

  isResetPassword(): boolean {
    return this.action === EditType.resetPassword;
  }

  isEdit(): boolean {
    return this.action === EditType.edit;
  }

  isRemove(): boolean {
    return this.action === EditType.remove;
  }

  getButtonName(): string {
    switch (this.action) {
      case EditType.add:
        return "Add";
      case EditType.edit:
        return "Update";
      case EditType.remove:
        return "Remove";
      case EditType.resetPassword:
        return "Reset Password";
    }
    return "";
  }
}
